export const QuoteType = 'QUOTE';
